var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import DuplicateProfileView from "./DuplicateProfileView";
import FAIcon from "../../UI/FAIcon/FAIcon";
import ModalHeader from "../../UI/Modal/ModalHeader";
import Modal from "../../UI/Modal/Modal";
import DuplicateConfirmationModal from "./DuplicateConfirmationModal";
export const MERGE_DIRECTION = {
    A_INTO_B: "left into right",
    B_INTO_A: "right into left",
};
// For AUTOMERGE, we are changing the position of each displayed person on the frontend, when necessary, to not impact
// performance on the backend.
// The person to be merged is always on the left (and is not necessarily person A) and the person to be merged into is
// always on the right (and is not necessarily person B).
// For TWO-WAY MERGES, the person displayed on the left is person A and the person displayed on the right is person B
// The same modal is currently being used by two-way merge, auto merge and just for review.
const DuplicateReviewModal = (_a) => {
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var { duplicate, noReviewAndMergeAllowed, unCheckStuff, setReviewModalOpen, refreshTable } = _a, modalProps = __rest(_a, ["duplicate", "noReviewAndMergeAllowed", "unCheckStuff", "setReviewModalOpen", "refreshTable"]);
    const [duplicateHasMerged, setDuplicateHasMerged] = useState(false);
    const [mergeDirection, setMergeDirection] = useState("");
    const [duplicateConfirmationModalIsOpen, setDuplicateConfirmationModalIsOpen,] = useState(false);
    // Check if this can be a two way merge
    const canMerge = duplicate.personA_IsMergeable &&
        duplicate.personB_IsMergeable &&
        !duplicate.ignored &&
        !duplicate.ezMerge;
    // Check if this can be a one way merge (automerge)
    const canAutomerge = !duplicate.ignored && duplicate.ezMerge;
    function handleMerge(direction) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!direction) {
                /*
                    If no direction is given, it's either an auto merge or this was called incorrectly. In the case of the former,
                    we'll check the mergeability of the duplicate to determine the direction. In the case of the latter, we should
                    still do the same to prevent errors.
                */
                if (duplicate.personA_IsMergeable) {
                    setMergeDirection(MERGE_DIRECTION.A_INTO_B);
                }
                else {
                    setMergeDirection(MERGE_DIRECTION.B_INTO_A);
                }
            }
            else {
                setMergeDirection(direction);
            }
            setDuplicateConfirmationModalIsOpen(true);
        });
    }
    // This is a component that goes in between the modal profiles that allows the user to pick the merge direction.
    const MergeDirectionPicker = () => {
        return (_jsx("div", { className: "d-flex justify-content-center", style: { width: "80px" }, children: _jsxs("div", { style: {
                    position: "fixed",
                    top: "50%",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    transform: "translateY(-50%)",
                    width: "80px",
                }, children: [canMerge && (_jsxs(_Fragment, { children: [_jsx("button", { type: "button", title: !duplicateHasMerged
                                    ? "Merge " + MERGE_DIRECTION.A_INTO_B
                                    : "This duplicate has already been merged", className: "btn btn-primary", style: { width: "fit-content" }, onClick: () => handleMerge(MERGE_DIRECTION.A_INTO_B), disabled: duplicateHasMerged, children: _jsx(FAIcon, { icon: "arrow-right", className: "font-weight-bold" }) }), _jsx("div", { style: { height: "100px" } }), _jsx("button", { type: "button", title: !duplicateHasMerged
                                    ? "Merge " + MERGE_DIRECTION.B_INTO_A
                                    : "This duplicate has already been merged", className: "btn btn-primary", style: { width: "fit-content" }, onClick: () => handleMerge(MERGE_DIRECTION.B_INTO_A), disabled: duplicateHasMerged, children: _jsx(FAIcon, { icon: "arrow-left", className: "font-weight-bold" }) })] })), canAutomerge && (_jsx("button", { type: "button", title: !duplicateHasMerged
                            ? "Automerge left into right"
                            : "This duplicate has already been merged", className: "btn btn-primary", style: { width: "fit-content" }, onClick: () => handleMerge(), disabled: duplicateHasMerged, children: _jsx(FAIcon, { icon: "arrow-right", className: "font-weight-bold" }) }))] }) }));
    };
    return (_jsxs(Modal, Object.assign({}, modalProps, { size: "fullscreen", children: [_jsx(ModalHeader, { title: noReviewAndMergeAllowed
                    ? "Duplicate Review"
                    : "Duplicate Merge Review", closeModal: () => modalProps.onModalClosed() }), _jsxs("div", { className: "d-flex flex-row p-3", children: [_jsx(DuplicateProfileView, { fullName: duplicate.personA_IsMergeable
                            ? (_b = duplicate.personA) === null || _b === void 0 ? void 0 : _b.fullName
                            : (_c = duplicate.personB) === null || _c === void 0 ? void 0 : _c.fullName, affiliationId: duplicate.personA_IsMergeable
                            ? (_d = duplicate.personA) === null || _d === void 0 ? void 0 : _d.affiliationId
                            : (_e = duplicate.personB) === null || _e === void 0 ? void 0 : _e.affiliationId }), _jsx(MergeDirectionPicker, { canAutomerge: canAutomerge }), _jsx(DuplicateProfileView, { fullName: duplicate.personA_IsMergeable
                            ? (_f = duplicate.personB) === null || _f === void 0 ? void 0 : _f.fullName
                            : (_g = duplicate.personA) === null || _g === void 0 ? void 0 : _g.fullName, affiliationId: duplicate.personA_IsMergeable
                            ? (_h = duplicate.personB) === null || _h === void 0 ? void 0 : _h.affiliationId
                            : (_j = duplicate.personA) === null || _j === void 0 ? void 0 : _j.affiliationId })] }), duplicateConfirmationModalIsOpen && (_jsx(DuplicateConfirmationModal, { isOpen: duplicateConfirmationModalIsOpen, onModalClosed: () => {
                    setDuplicateConfirmationModalIsOpen(false);
                }, unMountContentWhenClosed: true, mergeDirection: mergeDirection, duplicate: duplicate, setReviewModalOpen: setReviewModalOpen, setDuplicateConfirmationModalIsOpen: setDuplicateConfirmationModalIsOpen, setDuplicateHasMerged: setDuplicateHasMerged, refreshTable: refreshTable }))] })));
};
export default DuplicateReviewModal;
